var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.truncatedParts),function(part,index){return [(part.isMatch)?_c('span',{key:`highlight-result__target-${index}`,staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(part.text)+" ")]):_c('span',{key:`highlight-result__text-${index}`,staticClass:"text--secondary"},[_vm._v(" "+_vm._s(part.text)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }